import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

const ToggleWithLabel = ({ handleChange, leftRadioConfig, name, rightRadioConfig }) => {
  return (
    <div className="toggle">
      <label
        className={cn('toggle__left-item', { '-active': leftRadioConfig?.isChecked ?? false })}
      >
        <input
          className="toggle__input"
          name={name}
          onChange={handleChange}
          type="radio"
          value={leftRadioConfig?.value}
        />
        <span className="toggle__label">{leftRadioConfig?.label ?? ''}</span>
      </label>
      <label
        className={cn('toggle__right-item', { '-active': rightRadioConfig?.isChecked ?? false })}
      >
        <input
          className="toggle__input"
          name={name}
          onChange={handleChange}
          type="radio"
          value={rightRadioConfig?.value}
        />
        <span className="toggle__label">{rightRadioConfig?.label ?? ''}</span>
      </label>
      <div className="toggle__highlight" />
    </div>
  )
}

ToggleWithLabel.propTypes = {
  handleChange: PropTypes.func,
  name: PropTypes.string,
  leftRadioConfig: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    isChecked: PropTypes.bool,
  }),
  rightRadioConfig: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    isChecked: PropTypes.bool,
  }),
}

export default ToggleWithLabel
